module.exports = __webpack_public_path__ + "static/img/1.3d81b14.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/21/1.png
// module id = WFFM
// module chunks = 0